import React from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import { Redirect } from 'react-router-dom'
import { AUDIT_ACTION_LOGIN } from '../../constants'
import {
  getDocumentTypes,
  getHealthInsurances,
  getHealthInsurancePlans,
  logAuditAction,
  getPatientLogin
} from '../../api'
import { login as loginAction } from '../../actions'
import LoginForm from '../../components/forms/login'

class LogIn extends React.Component {
  state = { isLoggedIn: false, plans: [], documentTypes: [], healthInsurances: [] }

  componentWillMount() {
    this.checkLoggedInUser()
  }

  async componentDidMount() {
    const [err, [{ data: documentTypes } = {}, { data: healthInsurances } = {}] = []] = await to(
      Promise.all([getDocumentTypes(), getHealthInsurances()])
    )
    if (!err) {
      this.setState({
        documentTypes: documentTypes.map(dt => ({ id: dt.id, name: dt.nombre })),
        healthInsurances: healthInsurances.map(hi => ({ id: hi.id, name: hi.nombre }))
      })
    }
  }

  checkLoggedInUser = () => {
    if (Object.keys(this.props.auth).length) {
      this.setState({ isLoggedIn: true })
    }
  }

  auditUserLoggedIn = () => {
    const request = {
      documento: this.props.auth.nroDocumento,
      email: this.props.auth.mail,
      idObrasocial: this.props.auth.obraSocial.id,
      accion: AUDIT_ACTION_LOGIN
    }

    //logAuditAction(request)
  }

  handleSubmit = async values => {
    const request = {
      Documento: values.docNum,
      TipoDocumento: values.docType,
      ObraSocial: values.healthInsurance,
      Plan: values.healthPlan,
      Email: values.email,
      NroAfiliado: values.credential,
      phone: values.phoneNumber
    }
    const [err, { data } = {}] = await to(getPatientLogin(request))
    if (!err) {
      const patientExists = Array.isArray(data)
        ? data.length > 0
        : Boolean(data && Object.keys(data).length)

      const selectedTipoDocumento = this.state.documentTypes.find(
        dt => String(dt.id) === String(request.TipoDocumento)
      )

      this.props.loginAction({
        ...data,
        exists: patientExists,
        mail: values.email,
        nroDocumento: values.docNum,
        tipoDocumento: selectedTipoDocumento,
        obraSocial: this.state.healthInsurances.find(os => os.id === parseInt(request.ObraSocial)),
        plan: this.state.plans.find(hp => hp.id === parseInt(request.Plan)),
        credencial: values.credential,
        phone: values.phoneNumber
      })
      this.auditUserLoggedIn()
      this.checkLoggedInUser()
    }
  }

  handleHealthInsuranceChange = async value => {
    const [err, { data } = {}] = await to(getHealthInsurancePlans(value))
    if (!err) {
      this.setState({ plans: data.map(p => ({ id: p.id, name: p.nombre })) })
    }
  }

  render() {
    if (this.state.isLoggedIn) {
      return <Redirect to="/inicio" />
    }

    return (
      <LoginForm
        docTypes={this.state.documentTypes}
        plans={this.state.plans}
        healthInsurances={this.state.healthInsurances}
        handleSubmit={this.handleSubmit}
        onHealthInsuranceChange={this.handleHealthInsuranceChange}
      />
    )
  }
}

const mapDispatchToProps = { loginAction }
function mapStateToProps({ auth }) {
  return { auth }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogIn)
